// tslint:disable:no-any
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Redirect } from 'react-router';

import { GeneralResponse } from '../api';
import { DisplayDate, DisplayTime } from '../components/Display';
import DiveConfirmModal from '../components/DiveConfirmModal';
import Message from '../components/Message';
import NewDiveForm from '../components/NewDiveForm';
import Title from '../components/Title';
import Validation from '../components/Validation';
import {
    DEFAULT_MAP_CENTER,
    DEFAULT_MAP_ZOOM
} from '../constants/MapVariables';
import { DiveService } from '../services/DiveService';
import Dt from 'react-document-title';
import { NavigationStore } from './Navigation/NavigationStore';
import { convertDiveDataToSave } from './DiveData';
import DiveDataHeader from './DiveDataHeader';

// import Navigation from '../components/Navigation';
export interface INewDiveProps {}

interface INewDiveState {
    currentDiveId: any;
    currentDiveData: any;
    divesData: any;
    disableSubmit: boolean;
    confirmSubmit: boolean;
    uploadingFiles: any;
    nextLogIndex: any;
    canUploadFile: boolean;
    filesUploadedSuccess: any;
    filesUploadedError: any;
    divesConfirmSuccess: any;
    divesConfirmError: any;
    showConfirmSubmit: boolean;
    center: any;
    zoom: number;
    redirectToDashboardAfterConfirm: boolean;
    messages: any;
}

class NewDive extends Component<INewDiveProps, INewDiveState> {
    constructor(props: INewDiveProps) {
        super(props);
        this.state = {
            currentDiveId: null,
            currentDiveData: null,
            divesData: [],
            // nemoznost odeslat
            disableSubmit: false,
            // odeslani vyzaduje potvrzeni
            confirmSubmit: false,
            // nahravane soubory, kvuli ikonam
            uploadingFiles: [],
            // poradi souboru
            nextLogIndex: 1,
            // je mozne nahravat dalsi soubory
            canUploadFile: true,
            // messages
            filesUploadedSuccess: [],
            filesUploadedError: [],
            divesConfirmSuccess: [],
            divesConfirmError: [],
            // zobrazeni hlasky potvrzeni
            showConfirmSubmit: false,
            // data pro mapu
            center: DEFAULT_MAP_CENTER,
            zoom: DEFAULT_MAP_ZOOM,
            // redirect na dashboard
            redirectToDashboardAfterConfirm: false,
            messages: undefined
        };
    }

    componentDidMount() {
        // Navigation._setActive('dives', 'New log');
        NavigationStore.getInstance().setActive('dives');
        window.scrollTo(0, 0);

        NavigationStore.getInstance().setActive('dives');
    }

    public render() {
        const { currentDiveId, currentDiveData } = this.state;

        return (
            <Dt title={'WetNotes | New log'}>
                <div className="new-dive">
                    <Title
                        heading={'New Dive'}
                        breadcrumbs={[
                            { caption: 'My Dives', to: '/app/dives' },
                            { caption: 'New Dive', to: '/app/new-dive' }
                        ]}
                    />

                    {this.state.redirectToDashboardAfterConfirm && (
                        <Redirect
                            to={{
                                pathname: '/app',
                                state: {
                                    message:
                                        'Your files have been successfully uploaded',
                                    messageType: 'success'
                                }
                            }}
                        />
                    )}

                    <div className="wrapper">
                        <div>
                            <div className="standardContainer">
                                <h2 className="small">Upload New Dives</h2>
                                <span>
                                    Start by inserting your log files. Then
                                    enter the data for each dive.
                                </span>

                                <div className="messages">
                                    {this.state.filesUploadedSuccess.length >
                                        0 && (
                                        <Message
                                            type="success"
                                            text="Selected files (%s) were successfully uploaded"
                                            value={this.state.filesUploadedSuccess.join(
                                                ', '
                                            )}
                                            autoClose={true}
                                            onClose={() =>
                                                this.clearFilesUploadedSuccess()
                                            }
                                        />
                                    )}
                                    {this.state.filesUploadedError.length >
                                        0 && (
                                        <Message
                                            type="error"
                                            text="Selected files (%s) may not be valid. Please check the log files."
                                            value={this.state.filesUploadedError.join(
                                                ', '
                                            )}
                                            autoClose={true}
                                            onClose={() =>
                                                this.clearFilesUploadedError()
                                            }
                                        />
                                    )}
                                    {this.state.divesConfirmSuccess.length >
                                        0 && (
                                        <Message
                                            type="success"
                                            text="Dives (%s) have been successfully submitted"
                                            value={this.state.divesConfirmSuccess.join(
                                                ', '
                                            )}
                                            autoClose={true}
                                            onClose={() =>
                                                this.clearDivesConfirmSuccess()
                                            }
                                        />
                                    )}
                                    {this.state.divesConfirmError.length >
                                        0 && (
                                        <Message
                                            type="error"
                                            text="The dives (% s) could not be sent"
                                            value={this.state.divesConfirmError.join(
                                                ', '
                                            )}
                                            autoClose={true}
                                            onClose={() =>
                                                this.clearDivesConfirmError()
                                            }
                                        />
                                    )}
                                </div>

                                <Dropzone
                                    onDrop={f => this.uploadFile(f)}
                                    className={
                                        'dropbox' +
                                        (this.state.uploadingFiles.length > 0
                                            ? ' filled'
                                            : '')
                                    }
                                >
                                    {this.state.uploadingFiles.length === 0 && (
                                        <div className="in">
                                            <h3>Drag your files here</h3>
                                            <span>or</span>
                                            <br />
                                            <button className="btn btn--xsmallpill btn--colorRed btn--borderGray">
                                                Choose files
                                            </button>
                                        </div>
                                    )}

                                    {this.state.uploadingFiles.length > 0 && (
                                        <div className="icons">
                                            {this.state.divesData.length >
                                                1 && (
                                                <div
                                                    className="icon selectAll"
                                                    onClick={e => {
                                                        this.onSelectAllClick();
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    <span className="fileName">
                                                        Select all
                                                    </span>
                                                </div>
                                            )}
                                            {this.state.uploadingFiles.map(
                                                (file: any, i: number) => {
                                                    return (
                                                        <div
                                                            key={i}
                                                            className={
                                                                'icon ' +
                                                                file.status +
                                                                (file.selected
                                                                    ? ' selected'
                                                                    : '') +
                                                                (!file.valid
                                                                    ? ' error'
                                                                    : '') +
                                                                (file.required
                                                                    ? ' required'
                                                                    : '')
                                                            }
                                                            title={
                                                                file.description
                                                            }
                                                            onClick={e => {
                                                                this.onFileClick(
                                                                    file
                                                                );
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <div className="flag" />
                                                            <span className="fileName">
                                                                {file.logDate !==
                                                                    null && (
                                                                    <div className="iconDate">
                                                                        <DisplayDate
                                                                            data={
                                                                                file.logDate
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                                {file.logTime !==
                                                                    null && (
                                                                    <div className="iconTime">
                                                                        <DisplayTime
                                                                            data={
                                                                                file.logTime
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </span>
                                                            <span
                                                                className="delete"
                                                                title="Delete file"
                                                                onClick={e => {
                                                                    this.removeUploadDive(
                                                                        file.diveId
                                                                    );
                                                                    this.removeUploadFile(
                                                                        file.diveId
                                                                    );
                                                                    e.stopPropagation();
                                                                }}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            )}
                                            {this.state.canUploadFile && (
                                                <div
                                                    className="icon add"
                                                    title="Choose files"
                                                    onClick={this.uploadFile.bind(
                                                        this
                                                    )}
                                                />
                                            )}
                                        </div>
                                    )}
                                </Dropzone>
                            </div>
                        </div>

                        {this.state.divesData !== null &&
                            this.state.divesData.length > 0 && (
                                <div>
                                    <div className="standardContainer">
                                        {currentDiveId && currentDiveData
                                            ? (
                                                <DiveDataHeader
                                                    diveName={currentDiveData.fileDescription}
                                                    startDate={currentDiveData.diveAndMixes.dive.startDate}
                                                    duration={currentDiveData.diveAndMixes.dive.duration}
                                                    maxDepth={currentDiveData.diveAndMixes.dive.maxDepth}
                                                    averageDepth={currentDiveData.diveAndMixes.dive.averageDepth}
                                                />
                                            )
                                            : (
                                                <div className="standardContainer__header cf withTabs">
                                                    <div className="tab tabHeader">
                                                        <h3>All Dives</h3>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {this.state.currentDiveData !==
                                            null && (
                                            <NewDiveForm
                                                diveId={
                                                    this.state.currentDiveId
                                                }
                                                dive={
                                                    this.state.currentDiveData
                                                }
                                                divesData={this.state.divesData}
                                                onChangeDiveData={(e: any) =>
                                                    this.onChangeDiveData(e)
                                                }
                                                onChangeGpsData={(e: any) =>
                                                    this.onChangeGpsData(e)
                                                }
                                                onChangeDiveType={(
                                                    newDiveType: any
                                                ) =>
                                                    this.onChangeDiveType(
                                                        newDiveType
                                                    )
                                                }
                                                onChangeMixesData={(
                                                    newMixesData: any
                                                ) =>
                                                    this.onChangeMixesData(
                                                        newMixesData
                                                    )
                                                }
                                                isFieldValid={(e: any) =>
                                                    this.isFieldValid
                                                }
                                                confirmSubmit={
                                                    this.state.confirmSubmit
                                                }
                                                disableSubmit={
                                                    this.state.disableSubmit
                                                }
                                                showConfirmSubmit={(e: any) =>
                                                    this.showConfirmSubmit(e)
                                                }
                                                submitDivesData={(e: any) =>
                                                    this.submitDivesData(e)
                                                }
                                            />
                                        )}
                                    </div>
                                </div>
                            )}
                    </div>

                    <DiveConfirmModal
                        title="Are you sure you want to send all dives?"
                        description="Some dives are not filled in with all required data, GPS coordinates."
                        display={this.state.showConfirmSubmit}
                        hideConfirmSubmit={() => this.hideConfirmSubmit()}
                        submitDivesData={e => this.submitDivesData(e as any)}
                    />
                </div>
            </Dt>
        );
    }

    private isValid(response: any) {
        if (response !== undefined) {
            response.valid = true;

            Object.keys(response.validFields).forEach(field => {
                if (response.validFields[field] === false) {
                    response.valid = false;
                }
            });

            var newUploadingFiles = [...this.state.uploadingFiles];
            newUploadingFiles.map(f => {
                if (f.diveId === response.diveAndMixes.dive.id) {
                    f.valid = response.valid;
                }
                return f;
            });

            this.setState({
                uploadingFiles: newUploadingFiles
            });

            return response.valid === true;
        }

        return undefined;
    }

    private isRequired(response: any) {
        if (response !== undefined) {
            response.required = false;

            Object.keys(response.requiredFields).forEach(field => {
                if (response.requiredFields[field] === true) {
                    response.required = true;
                }
            });

            var newUploadingFiles = [...this.state.uploadingFiles];
            newUploadingFiles.map(f => {
                if (f.diveId === response.diveAndMixes.dive.id) {
                    f.required = response.required;
                }
                return f;
            });

            this.setState({
                uploadingFiles: newUploadingFiles
            });

            return response.required === true;
        }

        return undefined;
    }

    private isFieldValid(name: string, value: string, response: any) {
        var valid = true;

        switch (name) {
            case 'visibility':
            case 'surfaceTemp':
            case 'weight':
            case 'latitude':
            case 'longitude':
                valid = value === '' || Validation.isRealNumber(value);
                break;
            default:
                valid = true;
        }

        // data mixu
        if (
            name.substring(0, 10) === 'tankVolume' ||
            name.substring(0, 13) === 'startPressure' ||
            name.substring(0, 11) === 'endPressure'
        ) {
            valid =
                value === null ||
                value === '' ||
                Validation.isRealNumber(value);
        }

        if (response !== undefined) {
            // validace jedne vlastnosti
            response.validFields[name] = valid;
            // validace celeho ponoru
            this.isValid(response);
        }

        return valid;
    }

    private isFieldRequired(name: string, value: string, response: any) {
        var required = false;

        switch (name) {
            case 'latitude':
            case 'longitude':
                required =
                    value === '' || value === undefined || value === null;
                break;
            default:
                required = false;
        }

        if (response !== undefined) {
            // povinnost jedne vlastnosti
            response.requiredFields[name] = required;
            // povinnost celeho ponoru
            this.isRequired(response);
        }

        return required === true;
    }

    private setValidFieldMessage(name: string, message: string, response: any) {
        if (response !== undefined) {
            response.validFields[name] = message;

            Object.keys(response.validFields).forEach(field => {
                if (
                    response.validFields[field] !== true &&
                    response.validFields[field] !== null
                ) {
                    response.valid = false;
                }
            });
        }
    }

    private checkRequired() {
        var newRequiredAll = false;
        var newDivesData = [...this.state.divesData];

        // projde vsechny ponory
        newDivesData.forEach(diveElement => {
            // doporuceni zadani hodnot
            this.isFieldRequired(
                'latitude',
                diveElement.diveAndMixesConfirmation.dive.latitude,
                diveElement
            );
            this.isFieldRequired(
                'longitude',
                diveElement.diveAndMixesConfirmation.dive.longitude,
                diveElement
            );
            // test required
            if (diveElement.required) {
                newRequiredAll = true;
            }
        });

        this.setState({
            divesData: newDivesData,
            confirmSubmit: newRequiredAll
        });
    }

    private addFileUploadedSuccess(fileName: string) {
        var newFiles = [...this.state.filesUploadedSuccess];
        newFiles.push(fileName);

        this.setState({
            filesUploadedSuccess: newFiles
        });
    }

    private clearFilesUploadedSuccess() {
        if (this.state.filesUploadedSuccess.length > 0) {
            this.setState({
                filesUploadedSuccess: []
            });
        }
    }

    private addFileUploadedError(fileName: string) {
        var newFiles = [...this.state.filesUploadedError];
        newFiles.push(fileName);

        this.setState({
            filesUploadedError: newFiles
        });
    }

    private clearFilesUploadedError() {
        if (this.state.filesUploadedError.length > 0) {
            this.setState({
                filesUploadedError: []
            });
        }
    }

    /*private addDiveConfirmSuccess(fileName: string) {
        var newDives = [...this.state.divesConfirmSuccess];
        newDives.push(fileName);

        this.setState({
            divesConfirmSuccess: newDives
        });
    }*/

    private clearDivesConfirmSuccess() {
        if (this.state.divesConfirmSuccess.length > 0) {
            this.setState({
                divesConfirmSuccess: []
            });
        }
    }

    private addDiveConfirmError(fileName: string) {
        var newDives = [...this.state.divesConfirmError];
        newDives.push(fileName);

        this.setState({
            divesConfirmError: newDives
        });
    }

    private clearDivesConfirmError() {
        if (this.state.divesConfirmError.length > 0) {
            this.setState({
                divesConfirmError: []
            });
        }
    }

    /*private addMessage(
        text: string,
        type: string = 'info',
        autoClose: boolean = true
    ) {
        var newMessages = [...this.state.messages];
        newMessages.push({
            text: text,
            type: type,
            autoClose: autoClose
        });

        this.setState({ messages: newMessages });
    }*/

    private onSelectAllClick() {
        this.selectDive(null);
    }

    private onFileClick(file: any) {
        if (file.diveId !== undefined) {
            this.selectDive(file.diveId);
        }
    }

    private async uploadFile(files: any) {
        var newUploadingFiles = [...this.state.uploadingFiles];

        if (!Array.isArray(files)) {
            return;
        }

        var nextLogIndex = this.state.nextLogIndex;

        for (const file of files) {
            // zaznam nahravaneho souboru
            newUploadingFiles.push({
                index: newUploadingFiles.length + 1,
                logIndex: nextLogIndex,
                logDate: null,
                logTime: null,
                name: file.name,
                status: 'uploading',
                description: 'Log ' + nextLogIndex,
                valid: true,
                required: false
            });
            this.setState({
                uploadingFiles: newUploadingFiles
            });

            // dalsi v poradi
            nextLogIndex = nextLogIndex + 1;

            DiveService.getInstance()
                .createDivesFromFile(file)
                .then(
                    result => (result != undefined ? result.json() : undefined)
                )
                .then(response => {
                    // zpracovani nahraneho souboru
                    if (response.diveAndMixes !== undefined) {
                        // pridani poradi
                        response.fileName = file.name;
                        response.fileDescription = '';
                        response.fileUploadedStatus = 'done';
                        response.fileUploadedStatusDescription =
                            'File ' + file.name + ' uploaded successfully';
                        response.index = this.state.divesData.length + 1;
                        response.valid = true;
                        response.validFields = [];
                        response.required = false;
                        response.requiredFields = [];

                        // zmenim status u nahravaneho souboru
                        // navic musim zjistit pozici nahravaneho souboru
                        newUploadingFiles = [...this.state.uploadingFiles];
                        newUploadingFiles.forEach((f, index) => {
                            if (
                                f.name === file.name &&
                                f.status === 'uploading'
                            ) {
                                f.status = 'done';
                                // f.statusDescription = file.name;
                                f.diveId = response.diveAndMixes.dive.id;
                                f.logDate =
                                    response.diveAndMixes.dive.startDate;
                                f.logTime =
                                    response.diveAndMixes.dive.startDate;
                                // pozice souboru
                                response.index = index;
                                response.fileDescription = f.description;
                            }
                        });

                        // pridani zalozky ponoru na specificke misto
                        var newDivesData = [...this.state.divesData];
                        newDivesData.push(response);

                        // setridim zalozky
                        if (
                            Array.isArray(newDivesData) &&
                            newDivesData.length > 0
                        ) {
                            newDivesData.sort((a, b) => {
                                return a.index > b.index ? 1 : -1;
                            });
                        }

                        // hlaska
                        this.addFileUploadedSuccess(file.name);

                        // pridani noveho ponoru
                        this.setState(
                            {
                                divesData: newDivesData,
                                // currentDiveData: response,
                                uploadingFiles: newUploadingFiles
                            },
                            () => {
                                let filesToProcess = 0;
                                this.state.uploadingFiles.forEach(
                                    (pf: any, pi: any) => {
                                        if (pf.status === 'uploading') {
                                            filesToProcess = filesToProcess + 1;
                                        }
                                    }
                                );
                                if (
                                    this.state.divesData.length === 1 &&
                                    filesToProcess === 0
                                ) {
                                    this.selectDive(
                                        response.diveAndMixes.dive.id
                                    );
                                }
                                // vybere vychozi ponor
                                if (this.state.currentDiveData === null) {
                                    this.selectDive(
                                        response.diveAndMixes.dive.id
                                    );
                                }
                            }
                        );

                        // kontrola zadani povinnych udaju
                        this.checkRequired();
                    }

                    // chyba
                    if (response.errorText !== undefined) {
                        // chyba nahravani
                        // zmenim status u nahravaneho souboru
                        newUploadingFiles = [...this.state.uploadingFiles];
                        newUploadingFiles.forEach(f => {
                            if (
                                f.name === file.name &&
                                f.status === 'uploading'
                            ) {
                                f.status = 'error';
                            }
                        });

                        // hlaska
                        this.addFileUploadedError(file.name);

                        // pridani noveho ponoru
                        this.setState({
                            uploadingFiles: newUploadingFiles
                        });
                    }
                })
                .catch((error: any) => {
                    // tslint:disable-next-line:no-console
                    console.log('error', error);
                });
        }

        this.setState({
            nextLogIndex: nextLogIndex
        });
    }

    private selectDive(diveId: any) {
        var newCurrentDiveData = this.state.currentDiveData;

        this.state.divesData.forEach((dive: any, index: any) => {
            if (dive.diveAndMixes.dive.id === diveId) {
                newCurrentDiveData = dive;
            }
        });

        var newUploadingFiles = [...this.state.uploadingFiles];
        newUploadingFiles.map(f => {
            f.selected = f.diveId === diveId || diveId === null;
            return f;
        });

        this.checkRequired();

        this.setState({
            currentDiveId: diveId,
            currentDiveData: newCurrentDiveData,
            uploadingFiles: newUploadingFiles
        });
    }

    private removeUploadFile(diveId: any) {
        var newUploadingFiles = [...this.state.uploadingFiles];

        newUploadingFiles.forEach((file, index) => {
            if (file.diveId === diveId) {
                newUploadingFiles.splice(index, 1);
                // new state
                this.setState({
                    uploadingFiles: newUploadingFiles
                });
            }
        });
    }

    private removeUploadFiles() {
        this.setState({
            uploadingFiles: []
        });
    }

    private removeUploadFileIcon() {
        this.setState({
            canUploadFile: false
        });
    }

    private removeUploadDive(diveId: any) {
        var deleted = false;
        var nextDiveData: any = null;

        // nejdrive hledam dalsiho, ktereho vyberu, kdyz smazu vybraneho
        var newDivesData = [...this.state.divesData];
        newDivesData.forEach((diveToRemove, index) => {
            // objekt pro nahrazeni odstraneneho vybraneho ponoru
            if (
                (!deleted || nextDiveData === null) &&
                diveToRemove.diveAndMixes.dive.id !== diveId
            ) {
                nextDiveData = diveToRemove;
            }
            // ponor, ktery ma byt smazan
            if (diveToRemove.diveAndMixes.dive.id === diveId) {
                deleted = true;
            }
        });

        // smazu uvedeny ponor
        newDivesData.forEach((diveToRemove, index) => {
            if (diveToRemove.diveAndMixes.dive.id === diveId) {
                // remove five from new state
                newDivesData.splice(index, 1);
            }
        });

        // novy seznam ponoru
        this.setState(
            {
                divesData: newDivesData
            },
            () => {
                // vybrany jiny ponor, pokud se odstranil aktualne vybrany
                if (
                    this.state.currentDiveData !== null &&
                    this.state.currentDiveData.diveAndMixes &&
                    this.state.currentDiveData.diveAndMixes.dive &&
                    this.state.currentDiveData.diveAndMixes.dive.id ===
                        diveId &&
                    nextDiveData !== null &&
                    nextDiveData.diveAndMixes &&
                    nextDiveData.diveAndMixes.dive
                ) {
                    // vybere jiny ponor
                    this.selectDive(nextDiveData.diveAndMixes.dive.id);
                }

                // odebrani vsech ponoru
                if (this.state.divesData.length === 0) {
                    this.setState({
                        currentDiveId: null,
                        currentDiveData: null
                    });
                }
            }
        );
    }

    private async submitDivesData(event: any) {
        // odstraneni ikony plus (pridani)
        this.removeUploadFileIcon();
        // projdu seznam ponoru
        for (const diveData of this.state.divesData) {
            // convert dive data to save
            let newDiveData = convertDiveDataToSave({...diveData.diveAndMixesConfirmation});
            // data for update
            let saveDiveData = {
                dive: newDiveData.dive,
                mixes: newDiveData.mixes
            };
            const result = await DiveService.getInstance().submitDives(
                diveData.diveAndMixes.dive.id,
                saveDiveData
            );
            if (result == undefined) {
                console.log('Error while submiting dive data');
                return; // TODO: handle error
            }
            if ((result as GeneralResponse) != undefined) {
                // vse je v poradku
                // remove dive
                this.removeUploadDive(diveData.diveAndMixes.dive.id);

                // remove file icon by dive
                this.removeUploadFile(diveData.diveAndMixes.dive.id);

                // hlaska
                // this.addDiveConfirmSuccess(diveData.fileName);

                // pokud jiz nejsou dalsi soubory k uploadu, zpristupni se moznost nahravat dalsi
                if (this.state.divesData.length === 0) {
                    // odstraneni vsech, i chybnych souboru
                    this.removeUploadFiles();
                    // nastavi se zalozka obecnych informaci
                    this.selectDive(null);
                    // moznost uploadu dalsich souboru
                    /*this.setState({
        canUploadFile: true
      });*/

                    // vycistim vsechny hlasky
                    this.clearFilesUploadedSuccess();
                    this.clearFilesUploadedError();
                    this.clearDivesConfirmSuccess();
                    this.clearDivesConfirmError();

                    // redirect na dashboard, vc. hlasky
                    this.setState({
                        redirectToDashboardAfterConfirm: true
                    });
                }
            } else {
                const response = result as Response;
                if (response.status === 403 || response.status === 404) {
                    this.addDiveConfirmError(diveData.fileName);
                } else if (response.status === 409) {
                    // ponor jiz byl potvrzen
                    // remove dive
                    this.removeUploadDive(diveData.diveAndMixes.dive.id);
                    // remove file icon by dive
                    this.removeUploadFile(diveData.diveAndMixes.dive.id);
                    // hlaska
                    this.addDiveConfirmError(diveData.fileName);
                } else {
                    this.addDiveConfirmError(diveData.fileName);
                }
            }

            // skryti hlasky, pokud je zobrazena
            this.hideConfirmSubmit();

            event.preventDefault();
        }
    }

    private showConfirmSubmit(event: any) {
        this.setState({ showConfirmSubmit: true });
        event.preventDefault();
    }

    private hideConfirmSubmit() {
        this.setState({
            showConfirmSubmit: false
        });
    }

    private onChangeDiveData(event: any) {
        var paramName = event.target.name;
        var paramValue = event.target.value;

        var newDivesData = [...this.state.divesData];
        var newDisableSubmit = false;
        var newConfirmSubmit = false;

        newDivesData.forEach(diveElement => {
            if (
                this.state.currentDiveId === diveElement.diveAndMixes.dive.id ||
                this.state.currentDiveId === null
            ) {
                // nastaveni hodnoty
                diveElement.diveAndMixesConfirmation.dive[
                    paramName
                ] = paramValue;
                // souradnice
                if (paramName === 'latitude' || paramName === 'longitude') {
                    if (
                        paramValue !== '' &&
                        Validation.isRealNumber(paramValue)
                    ) {
                        diveElement.diveAndMixesConfirmation.dive[
                            paramName
                        ] = paramValue;
                    }
                }
                // kontrola validaec hodnoty
                this.isFieldValid(paramName, paramValue, diveElement);
            }
            // chyba v zadani jakehokoli z ponoru
            if (diveElement.valid !== true) {
                newDisableSubmit = true;
            }
            // doporuceni zadani hodnot
            if (diveElement.required === true) {
                newConfirmSubmit = true;
            }
        });

        this.setState({
            divesData: newDivesData,
            disableSubmit: newDisableSubmit,
            confirmSubmit: newConfirmSubmit
        });
    }

    private onChangeGpsData(event: any) {
        var newDivesData = [...this.state.divesData];
        var newDisableSubmit = false;
        var newConfirmSubmit = false;

        newDivesData.forEach(diveElement => {
            if (
                this.state.currentDiveId === diveElement.diveAndMixes.dive.id ||
                this.state.currentDiveId === null
            ) {
                diveElement.diveAndMixesConfirmation.dive.latitude = event.lat;
                diveElement.diveAndMixesConfirmation.dive.longitude = event.lng;
                // kontrola zadani povinnych udaju
                this.checkRequired();
                // kontrola validace ponoru
                this.isValid(diveElement);
            }
            // chyba v zadani jakehokoli z ponoru
            if (diveElement.valid !== true) {
                newDisableSubmit = true;
            }
            // doporuceni zadani hodnot
            if (diveElement.required === true) {
                newConfirmSubmit = true;
            }
        });

        this.setState({
            divesData: newDivesData,
            disableSubmit: newDisableSubmit,
            confirmSubmit: newConfirmSubmit
        });
    }

    private onChangeDiveType(newDiveType: any) {
        var newDivesData = [...this.state.divesData];

        newDivesData.forEach(diveElement => {
            if (
                this.state.currentDiveId === diveElement.diveAndMixes.dive.id ||
                this.state.currentDiveId === null
            ) {
                diveElement.diveAndMixesConfirmation.dive.diveType = newDiveType;
            }
        });

        this.setState({
            divesData: newDivesData
        });
    }

    private onChangeMixesData(newMixesData: any) {
        var newDivesData = [...this.state.divesData];
        var newDisableSubmit = false;
        var newConfirmSubmit = false;

        newDivesData.forEach(diveElement => {
            if (
                this.state.currentDiveId === diveElement.diveAndMixes.dive.id ||
                this.state.currentDiveId === null
            ) {
                diveElement.diveAndMixesConfirmation.mixes = newMixesData;
                // kontrola validace hodnot ze vsech mixu
                newMixesData.forEach((mixesData: any, index: number) => {
                    this.isFieldValid(
                        'tankVolume' + index,
                        mixesData.tankVolume,
                        diveElement
                    );
                    this.isFieldValid(
                        'startPressure' + index,
                        mixesData.startPressure,
                        diveElement
                    );
                    this.isFieldValid(
                        'endPressure' + index,
                        mixesData.endPressure,
                        diveElement
                    );

                    // vynulovani hlasky
                    this.setValidFieldMessage(
                        'endPressure' + index + 'message',
                        null as any,
                        diveElement
                    );
                    // validace start and end pressure
                    if (
                        parseFloat(mixesData.endPressure) >
                        parseFloat(mixesData.startPressure)
                    ) {
                        this.setValidFieldMessage(
                            'endPressure' + index + 'message',
                            'The start pressure has to be higher than the end pressure',
                            diveElement
                        );
                    }
                });
                // kontrola validace ponoru
                this.isValid(diveElement);
            }
            // chyba v zadani jakehokoli z ponoru
            if (diveElement.valid !== true) {
                newDisableSubmit = true;
            }
            // doporuceni zadani hodnot
            if (diveElement.required === true) {
                newConfirmSubmit = true;
            }
        });

        this.setState({
            divesData: newDivesData,
            disableSubmit: newDisableSubmit,
            confirmSubmit: newConfirmSubmit
        });
    }
}

export default NewDive;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NewDive.tsx